import React from 'react';
import { CheckmarkStroke } from '@bloomberg/media-ui-icons';

import { Toast } from '../Toast';
import type { GlobalProps } from '../types';
import { classes } from '../utils';

import styles from './styles.module.css';

export type ToastSuccessProps = GlobalProps & {
  open: boolean;
  text: string;
  autoHideDuration?: number;
  inline?: boolean;
};

export const ToastSuccess = React.forwardRef<HTMLDivElement, ToastSuccessProps>(
  function ToastSuccessComponent(props: ToastSuccessProps, ref) {
    const {
      className,
      name = 'toast-success',
      open,
      text,
      autoHideDuration,
      unstyled,
      inline = false,
    } = props;

    const cx = classes([className, styles.toastSuccess], {
      ...props,
      unstyled,
      name,
    });

    return (
      <Toast
        autoHideDuration={autoHideDuration}
        Icon={<CheckmarkStroke className={styles.toastSuccessIcon} />}
        className={cx}
        maxSize="full"
        name={name}
        open={open}
        position={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        ref={ref}
        variant="message"
        inline={inline}
      >
        {text}
      </Toast>
    );
  }
);
